/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { BackToTop } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IFarmlandsBackTopFooterProps } from './farmlands-back-top-footer.props.autogenerated';

/**
 *
 * BackTopFooter component
 * @extends {React.PureComponent<IFarmlandsBackTopFooterProps<{}>>}
 */
class BackTopFooter extends React.PureComponent<IFarmlandsBackTopFooterProps<{}>> {
    constructor(props: IFarmlandsBackTopFooterProps<{}>) {
        super(props);
    }
    public render(): JSX.Element | null {
        if (typeof document !== 'undefined' && typeof window !== 'undefined') {
            const backToTop = document.getElementById('farmlands-top');
            const myScrollFunc = () => {
                const yAxis = window.scrollY;
                if (backToTop) {
                    if (yAxis >= 800) {
                        backToTop?.classList.remove('farmlands-top--hide');
                        backToTop?.classList.add('farmlands-top--show');
                    } else {
                        backToTop?.classList.remove('farmlands-top--show');
                        backToTop?.classList.add('farmlands-top--hide');
                    }
                }
            };
            window.addEventListener('scroll', myScrollFunc);
        }

        if (this.props.config.destination === null) {
            this.props.telemetry.error('BackToTop.destination has not been provided, module wont render.');
            return null;
        }

        return (
            <BackToTop
                // href={this.props.config.destination}
                title={this.props.config.title}
                aria-label={this.props.config.ariaLabel}
            >
                {this.props.config.backtoTopText}
                <a className='material-icons farmlands-top farmlands-top--hide' id='farmlands-top'>
                    expand_less
                </a>
            </BackToTop>
        );
    }
}

export default BackTopFooter;
